import React from "react";
import { ChevronDown } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "./ui/collapsible";

const Row = ({ label, value, valueClass = "" }) => (
  <div className="flex items-center justify-between py-1.5">
    <span className="text-xs text-muted-foreground">{label}</span>
    <span className={`font-mono text-sm ${valueClass}`} style={{ fontFamily: "'Roboto Mono', monospace" }}>{value}</span>
  </div>
);

export const DebugPanel = ({ rows = [], testId }) => {
  return (
    <Collapsible>
      <CollapsibleTrigger
        data-testid={testId}
        className="flex w-full items-center justify-between rounded-[calc(var(--radius)-4px)] border border-border/70 bg-secondary/40 px-3 py-2.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
      >
        Durum / Debug
        <ChevronDown className="h-4 w-4" />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="mt-2 rounded-[calc(var(--radius)-4px)] border border-border/70 bg-secondary/40 px-3 py-2 divide-y divide-border/50">
          {rows.map((r) => (
            <Row key={r.label} {...r} />
          ))}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};
